<template>
    <div class="content order-list list">
        <div class="row">
            <div class="col-sm-12">
                <el-card>
                  <h4 style="color:#3b291d">Order List</h4>  
                  <!-- Start search part -->
                  <div class="row">
                    <div class="col-sm-5">
                      <base-input label="Campaign Date Range" class="range-picker">
                        <el-date-picker
                          type="daterange"
                          placeholder="Campaign Date Range"
                          v-model="searchForm.paymentDate"
                          class = "form-control"
                        >
                        </el-date-picker>
                      </base-input>
                      <!-- <base-input placeholder="" label="Tier" class="col-sm-9" style="margin-top:4px;" v-model="searchForm.tier">
                        <span slot="helpBlock" class="form-text">
                          A block of help text that breaks onto a new line.
                        </span>
                      </base-input> -->
                    </div>  
                    <div class="col-sm-5">
                      <base-input placeholder="" label="Salesman" style="margin-top:4px" v-model="test" required>
                        
                      </base-input>
                    </div>
                    <div class="col-sm-2">
                      <base-input placeholder="" label="Unit" style="margin-top:4px" v-model="searchForm.tier">
                      </base-input>
                    </div>
                  </div> 
                  <div class="row">
                    <div class="col-sm-5">
                      <base-input placeholder="" label="Contracting Party / Advertiser" style="margin-top:4px" v-model="searchForm.tier">
                      </base-input>
                    </div>  
                    <div class="col-sm-3">
                      <base-input placeholder="" label="Order No. / Contract No." style="margin-top:4px" v-model="searchForm.tier">
                      </base-input>
                    </div>
                    <div class="col-sm-2">
                      <base-input placeholder="" label="Product" style="margin-top:4px" v-model="searchForm.tier">
                      </base-input>
                    </div>
                    <div class="col-sm-2">
                        <base-button type="primary" style="width: calc(100% - 15px);top: 30px;" @click="testFun()">SEARCH</base-button>
                    </div>
                  </div>  
                  <!-- end Search part-->
                  <div class="row" style="margin-top:20px">
                    <div class="col-sm-12" style="display:flex">
                      <base-button type="link">
                        New Order
                      </base-button>
                      <div style="line-height:32px;cursor:pointer" @click="newOrder()">
                        <span class="add-button" >
                            +
                        </span>
                         New Order
                      </div>
                      <span style="margin-left:auto;line-height:32px;padding-right:20px">
                        Total No. of Record: {{total}}
                        <base-pagination
                          class="pagination-no-border"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="total"
                          :pagesToDisplay="20"
                          style="float:right"
                        >
                        </base-pagination> 
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <el-table :data="invoiceList">
                        <!-- <el-table-column type="No." label="No."  width="50"/> -->
                        <!-- <el-table-column prop="invNo" label="Invoice No."  /> -->
                        <el-table-column prop="unit" label="Unit"  width="70"/>
                        <el-table-column prop="order_no" label="Order No."  />
                        <el-table-column prop="contracting_party" label="Contracting Party" min-width="150"  />
                        <el-table-column prop="contract_no" label="Contract No." min-width="110"/>
                        <el-table-column prop="advertiser" label="Advertiser" />
                        <el-table-column prop="product" label="Product" >
                        </el-table-column>
                        <el-table-column prop="campagin_start" label="Campagin Start" min-width="150"/>
                        <el-table-column prop="campagin_end" label="Campaign End" min-width="150">
                          <!-- <div slot-scope="props">
                            <div>{{getMoneyFormat(props.row.TotalAmount)}}</div>
                          </div> -->
                        </el-table-column>
                        <el-table-column prop="salesman" label="Salesman">
                          <div slot-scope="props">
                            <div>{{getDate(props.row.PaymentDueDate)}}</div>
                          </div>
                        </el-table-column>
                        <el-table-column prop="created_date" label="Created Date" min-width="110">
                          <div slot-scope="props">
                            <div>{{getDate(props.row.InvoiceIssueDate)}}</div>
                          </div>
                        </el-table-column>
                        <el-table-column prop="status" label="Status" >
                          <div slot-scope="props">
                            <div>{{getPaymentStatus(props.row.PaymentStatus)}}</div>
                          </div>
                        </el-table-column>

                        <el-table-column prop="Action" label="Action" >
                          <div slot-scope="props">
                            <base-button
                              @click.native="goToInvoiceDraft(props.row)"
                              class="edit action-btn"
                              style="margin-right:5px"
                              size="sm"
                              icon
                            >
                              INV
                            </base-button>
                            <base-button
                              @click.native="goToInvoiceDraft(props.row)"
                              class="edit action-btn"
                              size="sm"
                              icon
                            >
                              PS
                            </base-button>
                          </div>
                        </el-table-column>
                      </el-table>
                      <div>
                      </div>
                    </div>
                  </div>
                </el-card>
            </div>
        </div>
    </div>
</template>


<script setup>
import { watch,ref } from 'vue'
import baseInput from "@/components/newUI/Inputs/BaseInput";
import baseButton from "@/components/newUI/BaseButton";
import basePagination from "@/components/newUI/BasePagination";
import router from "@/router/index";
const total = ref(10);
const searchForm = ref({
  tier:''
});
const test = ref('qwqwe');
const testWatcher = watch(test, (value, oldValue) => {
  console.log(value, oldValue)
})

const testFun = () => {
  console.log(test);
};
const newOrder = (command) => {
  router.replace("/newOrder1");
};

const pagination = ref({});

</script>



<style >
.content.order-list .form-group.has-label .el-input__inner {
    position: relative;
    top: 5px;
}

</style>
